import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { DocumentoService } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-devolucion-mercaderia-modal-devolver-documento',
  templateUrl: './modal-devolver-documento.component.html',
  styleUrls: ['../devolucion-mercaderia.component.scss'],
  providers: [SecurityService]
})
export class DevolucionMercaderiaModalDevolverDocumentoComponent implements OnInit {

  // Output
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('devolverDoc', { static: true }) devolverDocModal: ModalDirective;

  optionsMotivo: Array<any> = [];
  documento: any = null
  fechaEmision: any = null

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaRecorridos: Array<any> = null
  processing: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private motivoDevolucionService: MotivoDevolucionService,
    private documentoService: DocumentoService,
    private toastService: ToastService
  ) {
    this.log = this.clog.log('DEVOLVER-DOCUMENTO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadMotivoDevolucionGeneral()
    this.createForm()
  }

  private loadMotivoDevolucionGeneral() {
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsMotivo = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
    })
  }

  private createForm() {
    this.formHeader = this.fb.group({
      motivo: [null, [Validators.required]]
    });
  }

  show(documento: any, fechaEmision:any) {
    this.documento = documento
    this.fechaEmision = fechaEmision
    this.processing = false
    this.clearFormData()
    this.devolverDocModal.show()
  }

  clearFormData() {
    // this.formHeader.get('motivo').setValue(null)
    this.formValidatorsService.reset(this.formHeader)
  }

  devolverDocumento() {
    this.formValidatorsService.validate(this.formHeader)
    if (!this.formHeader.valid)
      return

    const inputParams = {
      nroRec: this.documento.recorrido_codigo,
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      nroDocto: this.documento.folio,
      tipoDocumento: this.documento.tipo_dte_codigo,
      motivoDevolucion: Number(this.formHeader.get('motivo').value),
      fechaEmision: this.fechaEmision
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.processing = true
    this.documentoService.devuelveDocumento(inputParams, ({ mensajes, respuesta }) => {

      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        this.processing = false

        if (mensajes.filter(m => m.tipo === "ERROR").length > 0)
          return
      }

      this.toastService.success('Operación exitosa')
      this.onSuccess.emit()
      this.devolverDocModal.hide()
      this.processing = false
    })
  }

}
